import { PerformanceAnalysisboardReq } from '@models/PerformanceAnalysisboard';
import { FilterCriteriaParam } from '@models/CommonParam';
import { ProductDataType } from '@pages/product-analyzer/Product';
import { getPeriodMetaFactory } from '@utils/PeriodUtils';
import { getCountryCodes } from '@utils/CountryUtils';
import { applyParamsBasedOnFilterPOST } from '@services/utils/OverviewServiceUtils';
import { getCollectionsLiveDataParams } from '@utils/collectionUtils/CollectionUtils';

export interface ExploreSegmentsStackedChartReq extends PerformanceAnalysisboardReq {}

export const constructSegmentStackedChartRequest = ({
  clientId,
  productType,
  countries,
  productGroup,
  period,
  comparisonPeriod,
  periodType,
  shareType,
  appliedFilters,
  segmentName,
  segmentDataType,
  kpi,
  segmentBy,
  segmentByDataType,
  isUsingCollectionLiveData = false,
}: FilterCriteriaParam): ExploreSegmentsStackedChartReq => {
  const req = {} as ExploreSegmentsStackedChartReq;
  const periodMetaForPA = getPeriodMetaFactory(period, comparisonPeriod, periodType);

  const stackedChartRequest = {
    ...req,
    clientId,
    productType,
    productDataType: ProductDataType.PerformanceAnalyzer,
    country: getCountryCodes(countries),
    periodType: periodType ? periodType.replace(/ /g, '').toUpperCase() : '',
    period: periodMetaForPA ? periodMetaForPA.currentPeriod.toUpperCase() : '',
    comparisonPeriod: periodMetaForPA ? periodMetaForPA.comparisonPeriod.toUpperCase() : '',
    shareType,
    showPerformance: segmentName,
    dataType: segmentDataType,
    kpi,
    segmentBy,
    segmentByDataType,
  };

  if (productGroup && productGroup.length !== 0) {
    stackedChartRequest.productGroup = productGroup.map((option) => {
      return option.value;
    });
  }

  applyParamsBasedOnFilterPOST(stackedChartRequest, appliedFilters);
  const collectionsParam = getCollectionsLiveDataParams(isUsingCollectionLiveData, periodType, comparisonPeriod);

  return {
    ...stackedChartRequest,
    ...collectionsParam,
  };
};
